import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const flashDataAcademyTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.flash_data_academy,
  logoUrl: "https://cdn.nemuru.com/assets/logos/flash-academy-logo.svg",
  palette: {
    primary: {
      main: "#09054C",
      contrastText: "#fff",
    },
    secondary: {
      main: "#ECA51A",
      contrastText: "#fff",
    },
    text: {
      title: "#09054C",
      primary: "#2e3439",
      secondary: "#666",
    },
    error: {
      light: "#f9ddd8",
      main: "#FF472D",
      dark: "#8b1503",
      contrastText: "#000",
    },
    warning: {
      light: "#ffe5b4",
      main: "#ECA51A",
      dark: "#ECA51A",
      contrastText: "#ffffff",
    },
    info: {
      light: "#eef5fd",
      main: "#36a3f7",
      dark: "#08404d",
      contrastText: "#fff",
    },
    success: {
      light: "#f1faf1",
      main: "#1c8135",
      dark: "#033d12",
      contrastText: "#000",
    },
    // additional colors
    dark: {
      main: "#eca51a66",
      accent: "#09054C",
      contrastText: "#09054C",
      imageBackgroundOpacity: 0.8,
    },
    status: {
      active: "#08C78F",
      approved: "#0c5741",
      analysing: "#36a3f7",
      sent: "#1c69d4",
      cancelled: "#d8d8d8",
      denied: "#dc0723",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#fff",
  typography: {
    fontFamily: "Hanken Grotesk, Ubuntu, Arial, Helvetica, sans-serif",
  },
  customBorderRadius: {
    button: 25,
    paper: 8,
    chip: 100,
  },
};
